import SmoothScroll from 'smooth-scroll';

export default {
  init: () => {
    let scroll = new SmoothScroll('a[href*="#"]');
  },
};
